export default __webpack_public_path__ + "static/logo-v3-daa05f17c53b93a0b89d0b6d1ed4244e.svg";